import { useQueryClient } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { useContext } from 'react'
import { clearTokens, setAccessToken, setRefreshToken } from '../../authentication/utilities'
import { encodeBase64 } from '../../components/mainTabs/WebAppLayout'
import { trpc } from '../../modules/trpc'
import { UserContext } from '../UserContext'

export const useLogin = () => {
	const queryClient = useQueryClient()
	const { setAuthExpire } = useContext(UserContext)

	const loginMutation = trpc.auth.login.useMutation({
		onSuccess: async response => {
			const { accessToken, refreshToken } = response

			const expireDate = dayjs().add(30, 'minute').toISOString()
			setAuthExpire(encodeBase64(expireDate))

			queryClient.setQueryData(['customAccessToken'], accessToken)
			await Promise.all([setAccessToken(accessToken), setRefreshToken(refreshToken)])
		},
		onError: error => {
			console.error('Login failed:', error)
		},
	})

	const tryLogin = async (email: string, password: string) => {
		clearTokens() // Clear any existing tokens before attempting login

		const result = await loginMutation.mutateAsync({ email, password })

		return result
	}

	return {
		login: tryLogin,
		error: loginMutation.error,
		isLoading: loginMutation.isLoading,
		isSuccess: loginMutation.isSuccess,
	}
}
